import { useState, useEffect, useCallback } from "react";
import { Request_Get_Axios, Request_Post_Axios } from "../../API";

export const usePhotos = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPhotos = useCallback(async () => {
    setLoading(true);
    try {
      const result = await Request_Get_Axios("/Dashboard/getImages");

      if (!result.status) throw new Error("데이터를 불러오지 못했습니다.");
      if (result.status) setPosts(result.data);
    } catch (err) {
      setError(err.message);
      setPosts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPhotos();
  }, [fetchPhotos]);

  // 데이터 삭제 로직
  const deletePost = async (id) => {
    try {
      const response = await Request_Post_Axios(
        `/Dashboard/deleteImages/${id}`,
      );
      if (!response.status) throw new Error("데이터를 불러오지 못했습니다.");
      if (response.status) {
        alert("삭제처리 완료 되었습니다.");
        setPosts((prev) => prev.filter((post) => post.id !== id));
        return true;
      }
    } catch (err) {
      console.error("삭제 실패:", err);
      setPosts((prev) => prev.filter((post) => post.id !== id));
      return true;
    }
    return false;
  };

  return { posts, loading, error, deletePost, refetch: fetchPhotos };
};
